import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';

const DynamicBigProductLine = dynamic(() => import('./big-product-line'), {
  ssr: false,
  loading: Skeleton
});

const BigProductLine = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicBigProductLine skeleton={skeleton} {...props} />;
};

export default BigProductLine;
